import { getCheckoutFields, getIsDeliveryWindowsLoading, getIsSavingAnything, getOrderDetails, getTermsText } from '@app/ducks';
import { mapOrderProductsToGAItems, useGTM } from '@app/utils/analytics';
import { useEffectOnce } from '@app/utils/hooks';
import { isDefined } from '@app/utils/is';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { OrderTopBar } from '../orders/OrderTopBar';
import { PageTitle } from '../various/PageTitle';

import { CheckoutContentSkeleton } from './CheckoutContent/CheckoutContentSkeleton';
import { CheckoutContent } from './CheckoutContent';
import { CheckoutTermsModal } from './CheckoutTermsModal';

export const Checkout = () => {
  const { t } = useTranslation(['checkout', 'selections']);
  const { trackGTMEvent } = useGTM();
  const termsText = useSelector(getTermsText);
  const orderDetails = useSelector(getOrderDetails);
  const isDeliveryWindowsLoading = useSelector(getIsDeliveryWindowsLoading);
  const isSaving = useSelector(getIsSavingAnything);
  const checkoutFields = useSelector(getCheckoutFields);
  const isLoadingOrder = !isDefined(orderDetails.order.order) || isDeliveryWindowsLoading;

  useEffectOnce(() => {
    trackGTMEvent('begin_checkout', {
      ecommerce: {
        currency: orderDetails.currency.currency,
        items: mapOrderProductsToGAItems(orderDetails, true),
        value: orderDetails.order.totals.itemsTotalPriceAsNumber,
      },
    });
  });

  return (
    <PageTitle title={t('checkout:checkout_page_title', { orderNumber: orderDetails.order.orderNumber })}>
      <OrderTopBar isCheckoutPage />
      <div className="mx-auto w-full max-w-screen-xl px-4 pb-16 lg:px-8">
        {isLoadingOrder ?
          <CheckoutContentSkeleton />
        : <CheckoutContent isSaving={isSaving} isLoading={isLoadingOrder} checkoutFields={checkoutFields} orderDetails={orderDetails} />}
      </div>
      <CheckoutTermsModal terms={termsText} />
    </PageTitle>
  );
};
